$(document).ready(function () {
  let timerContainer = $('.animation_activity_title .activity__sale-time');
  var countdownInterval = null
  if (timerContainer.length) {
    countdownInterval = setInterval(countclose, 1000);
  }

  function countclose() {
    // console.log("close")
    let now = new Date();
    let hours = 23 - now.getHours();
    let minutes = 59 - now.getMinutes();
    let seconds = 59 - now.getSeconds();

    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    // let countdownTimer = `<span class="fdt-end">End In</span><span class="smarck">:</span><span
    // class="fdt-hour"><span>${hours}</span></span> <span class="smarck">:</span><span
    // class="fdt-min"><span>${minutes}</span></span> <span class="smarck">:</span><span
    // class="fdt-second"><span>${seconds}</span></span>`;
    $(".flash__sale-btn .fdt-hour").html(`<span>${hours}</span>`)
    $(".flash__sale-btn .fdt-min").html(`<span>${minutes}</span>`)
    $(".flash__sale-btn .fdt-second").html(`<span>${seconds}</span>`)

    if (hours == 0 && minutes == 0 && seconds == 0) {
      clearInterval(countdownInterval);
      countclose();
    }
  }

  function IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) >= 0) {
        flag = false;
        break;
      }
    }
    return flag;
  }

  // <div
  //   className="swiper-pagination flash-product-pagination_{{ block.settings.item.id }} swiper-pagination-bullets"
  // >
  //   {% comment %}
  //   <div className="swiper-pagination-bullet  swiper-pagination-bullet-active">{% endcomment %}
  //     {% comment %}{% endcomment %}
  //     {% comment %}</div>
  //   {% endcomment %}
  //   {%- for imgs in block.settings.item.images -%}
  //   <div className="swiper-pagination-bullet"></div>
  //   {%- endfor -%}
  // </div>
  // <div className="shop-by-occasion__next paginantion_next">
  //   <svg className="icon" aria-hidden="true">
  //     <use xlink:href="#icon-right_arrow"></use>
  //   </svg>
  // </div>
  // <div className="shop-by-occasion__prev paginantion_prev">
  //   <svg className="icon" aria-hidden="true">
  //     <use xlink:href="#icon-left_arrow"></use>
  //   </svg>
  // </div>
  $(".activity_product_content .activity_item_add").on("click", function () {
    console.log("点击 buy now")
    let product_url = $(this).attr("data-url")
    window.location.href = product_url
  })

  function swipers() {
    if (!IsPC()) {
      let product_ids = $(".swiper-container_home")
      for (let i = 0; i < product_ids.length; i++) {
        let product_id = $(product_ids[i]).attr("data-product_id") || ""
        console.log("swiper flash_product_img", `#flash-product_img_${product_id} .swiper-container .swiper-wrapper`)
        // console.log($(`#flash-product_img_${product_id} #swiper-pagination-bullets`))
        new Swiper(`#flash-product_img_${product_id} .swiper-container`, {
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
          paginationClickable: true,
          pagination: $(`#flash-product_img_${product_id} .swiper-pagination-bullets`)[0],
        })
        // prevButton: $(`#flash-product_img_${product_id} .paginantion_prev`)[0],
        // nextButton: $(`#flash-product_img_${product_id} .paginantion_next`)[0],
        //   new Swiper(".activity_item_swipers " + ".swiper_box_" + product_id + " .swiper-wrapper")
      }
    } else {
      console.log("get", Swiper)
      let product_ids = $(".swiper-container_home")
      for (let i = 0; i < product_ids.length; i++) {
        let product_id = $(product_ids[i]).attr("data-product_id") || ""
        // console.log("swiper flash_product_img", `#flash-product_img_${product_id} .swiper-container .swiper-wrapper`)
        // console.log($(`#flash-product_img_${product_id} #swiper-pagination-bullets`))
        // console.log($(`#flash-product_img_${product_id} #paginantion_prev`))
        // console.log($(`#flash-product_img_${product_id} #paginantion_next`))
        new Swiper(`#flash-product_img_${product_id} .swiper-container`, {
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
          paginationType: "bullets",
          paginationClickable: true,
          pagination: $(`#flash-product_img_${product_id} .swiper-pagination-bullets`)[0],
          prevButton: $(`#flash-product_img_${product_id} .paginantion_prev`)[0],
          nextButton: $(`#flash-product_img_${product_id} .paginantion_next`)[0],
        })
        //   new Swiper(".activity_item_swipers " + ".swiper_box_" + product_id + " .swiper-wrapper")
      }
    }
  }


  // new Swiper("#flash-product_img3281" + " .swiper-container", {
  //   pagination: ".flash-product-pagination3281",
  //   // paginationClickable: true,
  //   prevButton: "#flash-product_img3281" + " .swiper-button-prev",
  //   nextButton: "#flash-product_img3281" + " .swiper-button-next",
  // });

  // new Swiper(".activity_product_content .swiper-container_{{ block.settings.item.id }}")
})
